import { appVersion } from './app-version';
import { AppConfiguration } from './AppConfiguration';
import { supportedLanguages } from './supported-languages';

export const environment: AppConfiguration = {
    production: true,
    instana: true,
    version: appVersion,
    env: 'production',
    app: {
        defaultLanguage: 'de-DE',
        supportedLanguages,
        roles: {
            admin: 'Quoteassistpro.Admin',
            customer: 'Quoteassistpro.Default',
        },
    },
    quest: {
        context: 'quest',
        dropoutGroup: 'Dropout',
        project: 'QuoteAssistPro',
        modelSelectionVariable: 'Anonymous.ProductGroup',
        preselectionVariable: 'Miscellaneous.PreSelection',
    },
    configit: {
        url: 'https://api.viessmann-climatesolutions.com/backend/modular-energy-center/v1',
        languages: ['de_DE'],
        salesAreaName: 'Germany',
        plant: '0500',
        usage: '5',
    },
    http: {
        baseUrl: 'https://api.viessmann-climatesolutions.com/backend/modular-energy-center/v1/',
        viBooksBaseUrl: 'https://vibooks.viessmann-climatesolutions.com',
        serviceConfiguratorBaseUrl: 'https://service-configurator.viessmann-climatesolutions.com',
        viOfferBaseUrl: 'https://offer.viessmann-climatesolutions.com',
        users: 'https://api.viessmann-climatesolutions.com/users/v1/users/me?sections=identity&sections=sales&sections=roles',
        translations:
            'https://api.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/639afeeb324ba95b71f9224e91925293/locales/',
        dswTranslations:
            'https://api.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/ec38b083a23c58c604a49d7f443dd7f2/locales/',
        statusPage: 'https://api.viessmann-climatesolutions.com/status/v1/apps/rhwny5sryyyt/summary',
        configuration: 'https://api.viessmann-climatesolutions.com/backend/configuration/v1/',
        pim: 'https://api.viessmann-climatesolutions.com/backend/pim/v1/',
        companyUrl: 'https://api.viessmann-climatesolutions.com/company/v3/companies/',
        quotation: 'https://api.viessmann-climatesolutions.com/quotation/v1/',
    },
    globalHeader: {
        baseUrl: 'https://api.viessmann-climatesolutions.com',
        accountAppUrl: 'https://account.viessmann-climatesolutions.com',
    },
    saml: {
        appId: 'modular-energy-center',
        baseUrl: 'https://api.viessmann-climatesolutions.com',
    },
    file: {
        uploadUrl: 'upload',
        downloadUrl: 'download',
    },
    feature: {
        salesorgSwitcher: false,
        allowFailingPriceCalc: false,
        voucherInput: true,
    },
    requireSalesOrg: true,
};
